import React from 'react';
import logo from './en.svg';
import './footer.css';

const Footer = () => (
  <div className="yellow__footer section__padding">
    <div className="yellow__footer-heading">
      <h1 className="gradient__text">Do you want to step in to the future before others</h1>
    </div>

    <div className="yellow__footer-btn">
      <p>Request Early Access</p>
    </div>

    <div className="yellow__footer-links">
      <div className="yellow__footer-links_logo">
        <img src={logo} alt="gpt3_logo" />
        <p>Optimized for impact, <br /> All Rights Reserved</p>
      </div>
      <div className="yellow__footer-links_div">
        <h4>Links</h4>
        <p>Overons</p>
        <p>Social Media</p>
        <p>Counters</p>
        <p>Contact</p>
      </div>
      <div className="yellow__footer-links_div">
        <h4>Company</h4>
        <p>Terms & Conditions </p>
        <p>Privacy Policy</p>
        <p>Contact</p>
      </div>
      <div className="yellow__footer-links_div">
        <h4>Get in touch</h4>
        <p>Johannesburg</p>
        <p>0798294423</p>
        <p>pitso.manyike@yellowaste.com</p>
      </div>
    </div>

    <div className="yellow__footer-copyright">
      <p>@2021 yellowaste. All rights reserved.</p>
    </div>
  </div>
);

export default Footer;